var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActionRefresh = function SvgActionRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.997 12.21a8 8 0 0 1-15.045 3.577H3.833a9 9 0 0 0 17.164-3.583l1.15 1.15a.5.5 0 0 0 .707-.708L20.5 10.293l-2.354 2.353a.5.5 0 0 0 .708.708zM12 3a9 9 0 0 1 8.166 5.21h-1.119a8 8 0 0 0-15.045 3.58l1.144-1.144a.5.5 0 0 1 .708.708L3.5 13.707l-2.354-2.353a.5.5 0 0 1 .708-.708l1.148 1.15A9 9 0 0 1 12 3"
  })));
};
export default SvgActionRefresh;